import { Reducer } from "redux";

import {
    GROUP_FEED_FETCH_SUCCESS,
    GroupFeedFetchSuccessAction,
} from "@/mk2/apps/groups/containers/GroupFeed/GroupFeed.actions";
import {
    GROUP_POST_DETAIL_FETCH_SUCCESS,
    GroupPostDetailFetchSuccessAction,
} from "@/mk2/apps/groups/containers/GroupPostDetail/GroupPostDetail.actions";
import {
    GROUP_SHARED_ASK_FOR_MEMBERSHIP_API_FAILURE,
    GROUP_SHARED_ASK_FOR_MEMBERSHIP_API_REQUEST,
    GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_FAILURE,
    GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_REQUEST,
    GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_SUCCESS,
    GROUP_SHARED_JOIN_GROUP_API_FAILURE,
    GROUP_SHARED_JOIN_GROUP_API_REQUEST,
    GROUP_SHARED_JOIN_GROUP_API_SUCCESS,
    GROUP_SHARED_LEAVE_GROUP_API_FAILURE,
    GROUP_SHARED_LEAVE_GROUP_API_REQUEST,
    GROUP_SHARED_LEAVE_GROUP_API_SUCCESS,
    GROUP_SHARED_SET_GROUP_AS_FAVORITE_API_FAILURE,
    GROUP_SHARED_SET_GROUP_AS_FAVORITE_API_REQUEST,
    GROUP_SHARED_SET_GROUP_AS_FAVORITE_API_SUCCESS,
    GroupSharedAskForMembershipApiFailureAction,
    GroupSharedAskForMembershipApiRequestAction,
    GroupSharedHidePostsOfAGroupInFeedApiFailureAction,
    GroupSharedHidePostsOfAGroupInFeedApiRequestAction,
    GroupSharedHidePostsOfAGroupInFeedApiSuccessAction,
    GroupSharedJoinGroupApiFailureAction,
    GroupSharedJoinGroupApiRequestAction,
    GroupSharedJoinGroupApiSuccessAction,
    GroupSharedLeaveGroupApiFailureAction,
    GroupSharedLeaveGroupApiRequestAction,
    GroupSharedLeaveGroupApiSuccessAction,
    GroupSharedSetGroupAsFavoriteApiFailureAction,
    GroupSharedSetGroupAsFavoriteApiRequestAction,
    GroupSharedSetGroupAsFavoriteApiSuccessAction,
} from "@/mk2/apps/groups/containers/GroupShared/GroupShared.actions";
import {
    FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS,
    ListOfGroupsFetchApiSuccessAction,
} from "@/mk2/apps/groups/containers/ListOfGroups/ListOfGroups.actions";
import { tupdate } from "@/mk2/helpers/types";

export interface State {
    askedForMembership: number[];
    joining: number[];
    favorites: number[];
    hiding: number[]; // groups which are being hidden/unhidden
    memberships: number[];
}

export const initialState: State = {
    askedForMembership: [],
    joining: [],
    favorites: [],
    hiding: [],
    memberships: [],
};

type GroupSharedActions =
    | GroupFeedFetchSuccessAction
    | GroupPostDetailFetchSuccessAction
    | GroupSharedAskForMembershipApiRequestAction
    | GroupSharedAskForMembershipApiFailureAction
    | GroupSharedJoinGroupApiRequestAction
    | GroupSharedJoinGroupApiSuccessAction
    | GroupSharedJoinGroupApiFailureAction
    | GroupSharedLeaveGroupApiRequestAction
    | GroupSharedLeaveGroupApiSuccessAction
    | GroupSharedLeaveGroupApiFailureAction
    | GroupSharedHidePostsOfAGroupInFeedApiRequestAction
    | GroupSharedHidePostsOfAGroupInFeedApiSuccessAction
    | GroupSharedHidePostsOfAGroupInFeedApiFailureAction
    | GroupSharedSetGroupAsFavoriteApiRequestAction
    | GroupSharedSetGroupAsFavoriteApiSuccessAction
    | GroupSharedSetGroupAsFavoriteApiFailureAction
    | ListOfGroupsFetchApiSuccessAction;

const reducer: Reducer<State> = (state: State = initialState, action: GroupSharedActions) => {
    switch (action.type) {
        case GROUP_SHARED_JOIN_GROUP_API_REQUEST:
        case GROUP_SHARED_LEAVE_GROUP_API_REQUEST:
            return tupdate(state, {
                joining: [...state.joining, action.groupId],
            });
        case GROUP_SHARED_JOIN_GROUP_API_FAILURE:
        case GROUP_SHARED_LEAVE_GROUP_API_FAILURE:
            return tupdate(state, {
                joining: state.joining.filter((id) => id !== action.groupId),
            });
        case GROUP_SHARED_JOIN_GROUP_API_SUCCESS:
        case GROUP_SHARED_LEAVE_GROUP_API_SUCCESS:
            return tupdate(state, {
                memberships: action.memberships,
                joining: state.joining.filter((id) => id !== action.groupId),
            });
        case GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_REQUEST:
            return tupdate(state, {
                hiding: [...state.hiding, action.groupId],
            });
        case GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_FAILURE:
        case GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED_API_SUCCESS:
            return tupdate(state, {
                hiding: state.hiding.filter((id) => id !== action.groupId),
            });
        case GROUP_SHARED_ASK_FOR_MEMBERSHIP_API_REQUEST:
            return tupdate(state, {
                askedForMembership: [...state.askedForMembership, action.groupId],
            });

        case GROUP_SHARED_ASK_FOR_MEMBERSHIP_API_FAILURE:
            return tupdate(state, {
                askedForMembership: state.askedForMembership.filter((id) => id !== action.groupId),
            });

        case GROUP_POST_DETAIL_FETCH_SUCCESS:
            return tupdate(state, {
                memberships: action.response.result.memberships,
            });

        case GROUP_FEED_FETCH_SUCCESS:
        case FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS:
            return tupdate(state, {
                askedForMembership: action.askedToJoin,
                memberships: action.memberships,
                favorites: action.favorites,
            });

        case GROUP_SHARED_SET_GROUP_AS_FAVORITE_API_REQUEST:
            if (action.setAsFavorite) {
                return tupdate(state, {
                    favorites: [...state.favorites, action.groupId],
                });
            } else {
                return tupdate(state, {
                    favorites: state.favorites.filter((id) => id !== action.groupId),
                });
            }

        case GROUP_SHARED_SET_GROUP_AS_FAVORITE_API_FAILURE:
            if (action.setAsFavorite) {
                return tupdate(state, {
                    favorites: state.favorites.filter((id) => id !== action.groupId),
                });
            } else {
                return tupdate(state, {
                    favorites: [...state.favorites, action.groupId],
                });
            }

        default:
            return state;
    }
};

export default reducer;
